export const TRACKED_URL_PARAMS = [
  'gclid', 'gbraid', 'wbraid', 'fbclid',
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
  'ref', 'cp',
] as const;

export type TrackedUrlParam = typeof TRACKED_URL_PARAMS[number];

export function parseUrlParams(
  search: string,
  hash: string,
): Partial<Record<TrackedUrlParam, string>> {
  const out: Partial<Record<TrackedUrlParam, string>> = {};
  const sources = [search, hash.replace(/^#/, '')];
  for (const src of sources) {
    if (!src) continue;
    const sp = new URLSearchParams(src.replace(/^\?/, ''));
    for (const name of TRACKED_URL_PARAMS) {
      const v = sp.get(name);
      if (v) out[name] = v;
    }
  }
  return out;
}
